/* Markup overlay styles */
.page {
  position: relative;
}

.page svg {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}

.page svg.markup-overlay {
  pointer-events: all;
}

.document-viewer {
  position: relative;
  height: 100%;
  width: 100%;
}

.document-viewer-toolbar {
  position: absolute;
  top: 50%;
  left: 15px;
  z-index: 1000;
  transform: translate(0%, -50%);
}

.document-viewer-modal__centered-items {
  display: flex;
}

.document-viewer-modal__searchbar {
  flex: 1;
  justify-content: center;
}

.document-separator {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin: 24px 0 8px;
}

.document-separator__label {
  display: inline-flex;
  align-items: center;
  padding: 4px 14px;
  border-radius: 999px;
  background: #3a3a3a;
  color: #ffffff;
  font-size: 0.75rem;
  font-weight: 500;
  white-space: nowrap;
}

.document-separator__accept {
  --color: var(--color-primary-1);
  margin: 0;
  height: auto;
  min-height: unset;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
